export const TWO_FACTOR_ATTEMPT = "TWO_FACTOR_ATTEMPT";
export const TWO_FACTOR_SUCCESS = "TWO_FACTOR_SUCCESS";
export const TWO_FACTOR_FAILED = "TWO_FACTOR_FAILED";
export const TWO_FACTOR_UPDATE_SUCCESS = "TWO_FACTOR_UPDATE_SUCCESS";
export const TWO_FACTOR_UPDATE_FAILED = "TWO_FACTOR_UPDATE_FAILED";
export const TWO_FACTOR_SETUP_SUCCESS = "TWO_FACTOR_SETUP_SUCCESS";
export const TWO_FACTOR_SEND_SUCCESS = "TWO_FACTOR_SEND_SUCCESS";
